import React from 'react';
import { motion } from 'framer-motion';

const spinTransition = {
  duration: 1,
  ease: [0, 0, 1, 1] as [number, number, number, number], // equivalent to 'linear'
  repeat: Infinity,
};

const Loader: React.FC = () => {
  return (
    <div className="flex items-center justify-center">
      <motion.div
        className="w-10 h-10 border-4 border-t-4 border-gray-200 border-t-blue-500 rounded-full"
        animate={{ rotate: 360 }}
        transition={spinTransition}
      />
    </div>
  );
};

export default Loader;
